module.exports = __webpack_public_path__ + "07df7620c3a18788d906fd945beeb5d1.webp";